/**
 * Magma block contact damage (vanilla MagmaBlock.stepOn): 1 fire-type damage
 * per tick to an entity standing on it (normal i-frames throttle it to ~1 per
 * 10 ticks), none while sneaking or for fire-immune entities. Does not ignite.
 */

import { MAGMA_ID } from '../blocks';

export function magmaDamage(blockUnderFeet: number, onGround: boolean, sneaking: boolean, fireImmune: boolean): number {
  if (blockUnderFeet !== MAGMA_ID || !onGround || sneaking || fireImmune) return 0;
  return 1;
}

/** Block under the feet of a box at (x, y, z) (feet slightly into the floor). */
export function blockUnderFeet(getBlock: (x: number, y: number, z: number) => number, x: number, y: number, z: number): number {
  return getBlock(Math.floor(x), Math.floor(y - 0.01), Math.floor(z));
}
